import { ENUM_MOD_PARAMETER } from "../../constants/enum"


const enum_GstType = {
  SGST: "SGST",
  CGST: "CGST",
  IGST: "IGST",
}
const enum_Report_Type = {
  MEMO: "MEMO",
  INVOICE: "INVOICE",
  RECVOUCHER: "REC_VOUCHER",
  PAYVOUCHER: "PAY_OUCHER",
  SALEMEMO: "SALE_MEMO",
  PURCHASEMEMO: "PURCHASE_MEMO",
  SALEINVOICE: "SALE_INVOICE",
  PURCHASEINVOICE: "PURCHASE_INVOICE",
  PACKETTRANSFER: "PACKET_TRANSFER"
}
export const ReportTemplateComponents = [{
  key: enum_Report_Type.SALEMEMO, data: [{ Code: "SMTMP1", Component: "RptMemo", Name: "Template-1" },
  { Code: "SMTMP2", Component: "RptSaleMemo", Name: "Template-2" }]
},
{ key: enum_Report_Type.SALEINVOICE, data: [{ Code: "SINVTMP1", Component: "RptInvoice", Name: "Template-1" }] },
{
  key: enum_Report_Type.PURCHASEMEMO, data: [{ Code: "PMTMP1", Component: "RptMemo", Name: "Template-1" },
  { Code: "PMTMP2", Component: "RptSaleMemo", Name: "Template-2" }]
},
{ key: enum_Report_Type.PURCHASEINVOICE, data: [{ Code: "PINVTMP1", Component: "RptInvoice", Name: "Template-1" }] },
{ key: enum_Report_Type.RECVOUCHER, data: [{ Code: "RCVTMP1", Component: "RptVoucher", Name: "Template-1" }] },
{ key: enum_Report_Type.PAYVOUCHER, data: [{ Code: "PAYVTMP1", Component: "RptVoucher", Name: "Template-1" }] }
]
export const TemplateReportType = [{ key: enum_Report_Type.SALEMEMO },
{ key: enum_Report_Type.SALEINVOICE },
{ key: enum_Report_Type.PURCHASEMEMO },
{ key: enum_Report_Type.PURCHASEINVOICE },
{ key: enum_Report_Type.RECVOUCHER },
{ key: enum_Report_Type.PAYVOUCHER },
]

const hasValue = (str) => {
  return str !== null && str !== undefined && str.trim() !== "";
};
const getInvoiceHead = (billType, entryType, docFor) => {
  if (billType == "S") return "T A X  I N V O I C E"
  else if (billType == "V")
    return entryType + ' Note  (' + docFor + ')'
  else return "J O B  I N V O I C E"
}
export const getMemoParticular = (visibleCol, row, PktType) => {

  let strParticur = ""
  // if (visibleCol.includes(ENUM_MOD_PARAMETER.MemoEntry.Items))
  //   strParticur = row.ItemName
  if (PktType == "SNG" || visibleCol.includes(ENUM_MOD_PARAMETER.MemoEntry.Shape))
    strParticur += hasValue(row?.ShapeName || "") ? row?.ShapeName : "";
  if (PktType == "SNG" || visibleCol.includes(ENUM_MOD_PARAMETER.MemoEntry.Color))
    strParticur += hasValue(row?.ColorName || "") ? " - " + row?.ColorName : "";
  if (PktType == "SNG" || visibleCol.includes(ENUM_MOD_PARAMETER.MemoEntry.Purity))
    strParticur += hasValue(row?.PurityName || "") ? " - " + row?.PurityName : "";
  if (PktType == "SNG")
    strParticur += hasValue(row?.CutName || "") ? " - " + row?.CutName : "";
  if (PktType == "SNG" || visibleCol.includes(ENUM_MOD_PARAMETER.MemoEntry.Size))
    strParticur += hasValue(row?.SizeName || "") ? " - " + row?.SizeName || "" : ""
  if ( PktType == "SNG" || visibleCol.includes(ENUM_MOD_PARAMETER.MemoEntry.LotNo))
    strParticur += hasValue(row?.L_Code || "") ? " - " + row?.L_Code || "" : ""
  if (PktType == "SNG" || visibleCol.includes(ENUM_MOD_PARAMETER.MemoEntry.PktNo))
    strParticur += hasValue(row?.PktNo || "") ? " - " + row?.PktNo || "" : ""
  if (visibleCol.includes(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio))
    strParticur += hasValue(row?.Lw_Code || "") ? " - " + row?.Lw_Code || "" : ""
  if (visibleCol.includes(ENUM_MOD_PARAMETER.MemoEntry.ReportNo))
    strParticur += hasValue(row?.ReportNo || "") ? " - " + row?.ReportNo || "" : ""
  if (visibleCol.includes(ENUM_MOD_PARAMETER.MemoEntry.Lab))
    strParticur += hasValue(row?.Lab || "") ? " - " + row?.Lab || "" : ""
  return strParticur

}
const getTotalTaxAmt = (amount, disc_Amt) => {
  if (
    amount != null &&
    amount != "" &&
    disc_Amt != null &&
    disc_Amt != ""
  )
    return amount - disc_Amt
  else return amount
}
export const getTradeOf = (tradeof) => {

  let trade_Type = ''
  if (tradeof == 'P')
    trade_Type = 'Polish'
  else if (tradeof == 'R')
    trade_Type = 'Rough'
  else if (tradeof == 'J')
    trade_Type = 'Rejection'
  return trade_Type
}
export const calTax = (amt, per) => {
  if (amt != "" && per != "") {
    return (parseFloat(amt) * parseFloat(per)) / 100
  }
  else
    return 0

}

export const getPktType = (pkttype) => {

  let pkt_Type = ''
  if (pkttype == 'SNG')
    pkt_Type = 'Single'
  else
    pkt_Type = 'Mix'
  return pkt_Type
}
export const getBillType = (billtype) => {
  let bill_Type = ''
  if (billtype == 'P')
    bill_Type = 'Purchase'
  else if (billtype == 'S')
    bill_Type = 'Sale'
  if (billtype == 'T')
    bill_Type = 'Sale Return'
  return bill_Type
}
const getItemQty = (itemUnit, billDmt, billDno, billDwgt) => {
  let rtnValue = ""
  if (itemUnit == "PCS" || itemUnit == "NOS" || itemUnit == "BOX") {
    rtnValue = billDno
  } else if (itemUnit == "MTR" || itemUnit == "LTR") {
    rtnValue = billDmt
  } else {
    rtnValue = billDwgt
  }
  return rtnValue
}
const getDateFn = (_date) => {

  if (typeof _date == Date) return new Date(_date).toISOString().split("T")[0]
  else return String(_date).slice(0, 10).split("-").reverse().join("-");
}
const getIrnNo = (data, line) => {
  if (data && data != "") {
    if (data.length > 40) {
      if (line == 1)
        return data.slice(0, 40).toString();
      else
        return data.slice(40).toString();
    }
    else
      return data
  }
  else
    return data
}
const getTotalGstAmt = (amt_STAmt, amt_ASTAmt) => {
  let totalTaxAmt = 0
  if (
    amt_STAmt != null &&
    amt_STAmt != "" &&
    amt_ASTAmt != null &&
    amt_ASTAmt != ""
  ) {
    totalTaxAmt = amt_STAmt + amt_ASTAmt
  }
  return totalTaxAmt
}
const getNetRate = (netAmt, itemUnit, meter, weight, nos) => {
  let Rate = 0
  if (netAmt > 0) {
    if ((itemUnit = "MTR")) if (meter > 0) Rate = netAmt / meter; else Rate = 0;
    else if ((itemUnit = "KGS")) if (weight > 0) Rate = netAmt / weight; else Rate = 0;
    else if (nos > 0) Rate = netAmt / nos; else Rate = 0;
    if (Rate > 0)
      return Rate.toFixed(2)
    return ""
  }
}
const getTDSCaption = (tdsAmt, tdsPer) => {
  if (tdsAmt > 0) return "TDS @ " + toString(tdsPer, 2) + " % :"
  else return ""
}
const getGstTax = (tradeType, gstType) => {
  if (gstType == enum_GstType.SGST || gstType == enum_GstType.CGST) {
    if (tradeType == "RD" || tradeType == "URD") return true
    else return false
  } else if (gstType == enum_GstType.IGST) {
    if (tradeType != "RD" && tradeType != "URD") return true
    else return false
  }
}
const getGSTPer = (tradeType, gstType) => {
  console.log(tradeType, gstType)
  if (gstType == enum_GstType.SGST || gstType == enum_GstType.CGST) {
    if (tradeType == "RD" || tradeType == "URD") return true
    else return false
  }
  else if (gstType == enum_GstType.IGST) {

    if (tradeType != "RD" && tradeType != "URD") return true
    else return false
  }
}
const getTotalInvoiceAmt = (netAmt, tcsAmt, tdsAmt) => {
  let val = netAmt
  if (tcsAmt == null || tcsAmt == "")
    tcsAmt = 0;
  if (tdsAmt == null || tdsAmt == "")
    tdsAmt = 0
  val = Math.round((netAmt + tcsAmt) - tdsAmt).toFixed(2)
  return val
}
const getTotalAmtToShow = (netAmt, tcsAmt) => {
  if (tcsAmt != null && tcsAmt != "")
    return Math.round((netAmt + tcsAmt))
  else return netAmt
}
const getTaxableAmt = (Amount, discAmt) => {

  if (discAmt != "" && Amount != "") {
    return Amount - discAmt
  }
  else return Amount;
}
const getAmountToWords = (num) => {
  const belowTwenty = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen'
  ];

  const tens = [
    '',
    '',
    'Twenty',
    'Thirty',
    'Forty',
    'Fifty',
    'Sixty',
    'Seventy',
    'Eighty',
    'Ninety'
  ];

  const thousands = [
    '',
    'Thousand',
    'Million',
    'Billion'
  ];

  if (num === 0) return 'Zero';

  let words = '';
  let thousandIndex = 0;

  while (num > 0) {
    let part = num % 1000;
    if (part) {
      let partWords = '';
      if (part >= 100) {
        partWords += belowTwenty[Math.floor(part / 100)] + ' Hundred';
      }
      part %= 100;
      if (part < 20) {
        partWords += (partWords ? ' ' : '') + belowTwenty[part];
      } else {
        partWords += (partWords ? ' ' : '') + tens[Math.floor(part / 10)];
        if (part % 10 > 0) {
          partWords += ' ' + belowTwenty[part % 10];
        }
      }
      words = partWords.trim() + (thousands[thousandIndex] ? ' ' + thousands[thousandIndex] : '') + ' ' + words;
    }
    num = Math.floor(num / 1000);
    thousandIndex++;
  }

  return words.trim() + "Rs. Only ";
}




// const getAmountToWords = (amount) => {
//   // Define arrays for one to nineteen, tens, and thousands
//   const oneToNineteen = [
//     "",
//     "one",
//     "two",
//     "three",
//     "four",
//     "five",
//     "six",
//     "seven",
//     "eight",
//     "nine",
//     "ten",
//     "eleven",
//     "twelve",
//     "thirteen",
//     "fourteen",
//     "fifteen",
//     "sixteen",
//     "seventeen",
//     "eighteen",
//     "nineteen",
//   ]
//   const tens = [
//     "",
//     "",
//     "twenty",
//     "thirty",
//     "forty",
//     "fifty",
//     "sixty",
//     "seventy",
//     "eighty",
//     "ninety",
//   ]
//   const thousands = ["", "thousand", "million", "billion", "trillion"]

//   // Helper function to convert a three-digit number into words
//   function convertThreeDigitNumber(num) {
//     let result = ""

//     if (num >= 100) {
//       result += oneToNineteen[Math.floor(num / 100)] + " hundred "
//       num %= 100
//     }

//     if (num >= 20) {
//       result += tens[Math.floor(num / 10)] + " "
//       num %= 10
//     }

//     if (num > 0) {
//       result += oneToNineteen[num] + " "
//     }

//     return result.trim()
//   }

//   // Main conversion process
//   if (amount === 0) {
//     return "zero"
//   }

//   let words = ""
//   let i = 0

//   while (amount > 0) {
//     if (amount % 1000 !== 0) {
//       words =
//         convertThreeDigitNumber(amount % 1000) + thousands[i] + " " + words
//     }
//     amount = Math.floor(amount / 1000)
//     i++
//   }

//   return words.trim()
// }

export {
  getItemQty,
  getTotalTaxAmt,
  getTotalGstAmt,
  enum_GstType,
  enum_Report_Type,
  getGstTax,
  getTotalInvoiceAmt,
  getDateFn,
  getTDSCaption,
  getAmountToWords,
  getNetRate, getTaxableAmt,
  getInvoiceHead,
  getGSTPer,
  getIrnNo,
  getTotalAmtToShow
}
